import { get, post } from './client';

/**
 * 客服模块 API。
 * 普通用户可用能力：获取客服信息（公开）、提交留言（公开）。
 * 留言列表为管理员专属接口，用户端不提供。
 */

/** 客服信息（后台「客服管理」维护） */
export interface CustomerServiceInfo {
  id: string;
  serviceName: string;
  phone: string;
  qrCodeUrl?: string | null;
  wechatQrCodeUrl?: string | null;
  email?: string | null;
  address?: string | null;
  workingHours?: string | null;
  description?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/** 获取启用中的客服信息列表（公开接口） */
export async function getActiveCustomerServices() {
  return get<CustomerServiceInfo[]>('/customer-service', {
    params: { activeOnly: true },
  });
}

/** 提交留言请求体 */
export interface CustomerMessagePayload {
  customerName: string;
  customerPhone: string;
  customerEmail?: string;
  message: string;
}

/** 提交留言（公开接口；成功后由管理员在后台处理回复） */
export async function submitCustomerMessage(data: CustomerMessagePayload) {
  return post<{ id?: string }>('/customer-service/messages', data);
}